import { useState } from "react";

import { Icon } from "../../../../../../Elements/Icon";

import * as styles  from "./styles.module.scss";

export const VersionSelection = ({
    language,
    version,
    setVersion,
}) => {
    if (!language?.versions || language?.versions.length < 2) {
        return null;
    }

    return (
        <div className={styles.container}>
            <select className={styles.select} onChange={(event) => setVersion(event.target.value)} value={version?.slug}>
                {language.versions.map((version) => (
                    <option key={version.slug} value={version.slug}>
                        Version: {version.name}
                    </option>
                ))}
            </select>
        </div>
    );
};
